export default __webpack_public_path__ + "static/6800-3e2684bb9523c982fedb97a21a4bb609.jpg";